/** Kuratierte offene Lesesilben für das Blitzlesen. */
export const BLITZLESEN_EINFACHE_SILBEN = [
  "ma", "me", "mi", "mo", "mu",
  "la", "le", "li", "lo", "lu",
  "ra", "re", "ri", "ro", "ru",
  "na", "ne", "ni", "no", "nu",
  "sa", "se", "si", "so", "su",
  "fa", "fe", "fi", "fo", "fu",
  "wa", "we", "wi", "wo", "wu",
  "ba", "be", "bi", "bo", "bu",
  "da", "de", "di", "do", "du",
  "ga", "ge", "gi", "go", "gu",
  "ka", "ke", "ki", "ko", "ku",
  "pa", "pe", "pi", "po", "pu",
  "ta", "te", "ti", "to", "tu",
  "ha", "he", "hi", "ho", "hu",
] as const;

/** Kuratierte offene Lesesilben mit Konsonantenverbindungen im Anlaut. */
export const BLITZLESEN_KONSONANTENVERBINDUNGEN = [
  "bla", "ble", "bli", "blo", "blu",
  "bra", "bre", "bri", "bro", "bru",
  "dra", "dre", "dri", "dro", "dru",
  "fla", "fle", "fli", "flo", "flu",
  "fra", "fre", "fri", "fro", "fru",
  "gla", "gle", "gli", "glo", "glu",
  "gra", "gre", "gri", "gro", "gru",
  "kla", "kle", "kli", "klo", "klu",
  "kra", "kre", "kri", "kro", "kru",
  "pla", "ple", "pli", "plo", "plu",
  "pra", "pre", "pri", "pro", "pru",
  "tra", "tre", "tri", "tro", "tru",
  "schla", "schle", "schli", "schlo", "schlu",
  "schra", "schre", "schri", "schro", "schru",
] as const;
